import { render, staticRenderFns } from "./OwalPanelHeaderButton.vue?vue&type=template&id=434490e0&scoped=true"
import script from "./OwalPanelHeaderButton.vue?vue&type=script&lang=js"
export * from "./OwalPanelHeaderButton.vue?vue&type=script&lang=js"
import style0 from "./OwalPanelHeaderButton.vue?vue&type=style&index=0&id=434490e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434490e0",
  null
  
)

export default component.exports